import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { EventReminder } from 'src/app/events-v4/shared/notifications/event-reminder.model';
import { EventEdit } from 'src/app/events/shared/event-edit.model';
import { EventV4ReminderService } from 'src/app/events-v4/shared/notifications/event-v4-reminder.service';
import { NotificationService } from 'src/app/shared';
import { EventV4SettingsNotificationReminderEditDialogComponent } from './event-v4-settings-reminder-edit-dialog/event-v4-settings-reminder-edit-dialog.component';
import { TimeZone } from '../../../../config/shared/time-zone/time-zone.model';
import { TimeZoneService } from '../../../../config/shared/time-zone/time-zone.service';

@Component({
  selector: 'wl-event-v4-settings-notification-reminder',
  templateUrl: './event-v4-settings-reminder.component.html',
  styleUrl: './event-v4-settings-reminder.component.less',
    standalone: false
})
export class EventV4SettingsNotificationReminderComponent implements OnInit, OnChanges {
  @Input() public event: EventEdit;

  @ViewChild(EventV4SettingsNotificationReminderEditDialogComponent)
  _editReminderDialogComponent: EventV4SettingsNotificationReminderEditDialogComponent;

  public loading: boolean;
  public showDeleteModal: boolean;
  public deleting: boolean = false;
  public reminders: Array<EventReminder>;
  private reminderToDelete: EventReminder;
  public eventTimeZone: TimeZone;

  constructor(
    private _reminderService: EventV4ReminderService,
    private _notificationService: NotificationService,
    private _timezoneService: TimeZoneService
  ) {}

  ngOnInit(): void {
    if (this.event && this.event.EventId > 0) {
      this.getReminders();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.event && changes.event.currentValue.EventId > 0) {
      this.getReminders();
    }
  }

  public getReminders() {
    this.loading = true;
    Promise.all([
      this._reminderService.getRemindersForEvent(this.event.EventId).then((data: Array<EventReminder>) => {
        this.reminders = data;
      }),
      this._timezoneService.getTimeZone(this.event.TimeZoneId).then((data) => {
        this.eventTimeZone = data;
      }),
    ])
      .catch((error) => {
        this._notificationService.httpError(error);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  newReminder() {
    this.openEditDialog({} as EventReminder);
  }

  openEditDialog(reminder: EventReminder) {
    this._editReminderDialogComponent.openDialog(reminder);
  }

  openDeleteDialog(reminder: EventReminder) {
    this.reminderToDelete = reminder;
    this.showDeleteModal = true;
  }

  deleteReminder() {
    const draftId = this.reminderToDelete?.DraftMessageId > 0 ? this.reminderToDelete.DraftMessageId : undefined;
    const messageId = this.reminderToDelete?.MessageId > 0 ? this.reminderToDelete.MessageId : undefined;
    this.deleting = true;
    this._reminderService
      .deleteReminder(draftId, messageId)
      .then(() => {
        this.showDeleteModal = false;
        this.getReminders();
      })
      .catch((error) => {
        this.deleting = false;
        this._notificationService.httpError(error);
      })
      .finally(() => {
        this.deleting = false;
      });
  }

  onReminderSaved() {
    this.getReminders();
  }
}
